import styled from '@emotion/styled';
import CreativeStrategyInsights from './CreativeStrategyInsights';
import DemographicOverview from './DemographicOverview';
import ShoppingBehavior from './ShoppingBehavior';

const TopItemsSection = styled.div`
  display: block;
  padding: 20px 60px 40px 60px;
  background: #f5f5f5;

  h2 {
    margin-bottom: 8px;
    color: #333;
    font-size: 1.8em;
  }

  p {
    margin: 0 0 30px 0;
    color: #777;
    font-size: 1em;
    line-height: 1.4;
  }

  > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
`;

type OverallPopulation = {
  age_distribution?: Record<string, number>;
  gender_distribution?: Record<string, number>;
  residence_type_breakdown?: Record<string, number>;
};

type BrandProduct = {
  product_category: string;
  percentage_of_buyers: number;
};

const CustomerOverviewView = ({
  brandProducts,
  brandPersonasData
}: {
  brandProducts: Record<string, unknown>[];
  brandPersonasData: {
    personasData: {
      personas: unknown[];
      overall_population: unknown;
      other_brands_analysis: unknown;
    };
    other_brands_analysis: {
      specialized_tag_types: unknown[];
    };
    crossBrandPurchases: unknown[];
  };
}) => {
  // Get overall population data from the first persona
  const overallPopulation = brandPersonasData?.personasData?.overall_population as
    | OverallPopulation
    | undefined;

  return (
    <div>
      <TopItemsSection>
        <h2>Customer Overview - All Personas</h2>
        <p>
          Request custom audiences built from any of these values by{' '}
          <a
            href="https://calendly.com/d/cw35-8fj-w7r"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#7c3aed', textDecoration: 'underline' }}
          >
            scheduling a call
          </a>
          .
        </p>
      </TopItemsSection>
      <DemographicOverview overallPopulation={overallPopulation} />
      <CreativeStrategyInsights brandPersonasData={brandPersonasData} />
      <ShoppingBehavior brandProducts={brandProducts as BrandProduct[]} />
    </div>
  );
};

export default CustomerOverviewView;
